import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=fc603a04&scoped=true&"
import script from "./Identify.vue?vue&type=script&lang=js&"
export * from "./Identify.vue?vue&type=script&lang=js&"
import style0 from "./Identify.vue?vue&type=style&index=0&id=fc603a04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc603a04",
  null
  
)

export default component.exports